var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3216 0.678819C14.6963 1.05359 14.6963 1.66113 14.3216 2.0359L2.10786 14.2521C1.73306 14.627 1.1253 14.627 0.750501 14.2521V14.2521C0.375808 13.8774 0.375807 13.2698 0.750501 12.8951L12.9642 0.678818C13.339 0.303939 13.9468 0.30394 14.3216 0.678819V0.678819Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2495 14.3212C14.6242 13.9464 14.6242 13.3389 14.2495 12.9641L2.03576 0.747858C1.66096 0.372979 1.0532 0.372981 0.678402 0.74786V0.74786C0.303708 1.12263 0.303708 1.73017 0.678402 2.10494L12.8921 14.3212C13.2669 14.6961 13.8747 14.6961 14.2495 14.3212V14.3212Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.ca2d911f7fd57109f70adef852510ceb.svg";
export { ForwardRef as ReactComponent };